var _ = require('underscore');
// // Interface for a PopHandler implementation.
// var PopHandler = function() {};
//
// // Returns a String name that's unique for this handler.
// PopHandler.prototype.name;
//
// // Set the current state. This state was previously passed to pushState
// // with this handler.
// PopHandler.prototype.restoreState = function(state) {};
//
// // Transform state to a url. Returns a String that can be used to set
// // window.location.
// PopHandler.prototype.stateToUrl = function(state) {};
//
// // Transform window.location back into a state object that can be used to
// // initialize the current state when the page loads.
// PopHandler.prototype.urlToState = function(windowLocation) {};

// PushState.
var PushState = function(window) {
  this.window = window;
  this.handlers = {};
  this.currentState = null;

  // Bind to the window's onpopstate.
  this.window.onpopstate = _.bind(this._stateDidPop, this);
};

// Determine if the current browser supports pushState.
//
// Returns a Boolean.
PushState.prototype.pushStateIsSupported = function() {
  return !!(this.window.history && this.window.history.pushState);
};

// Initialize the current state when the page first loads. First, we need to
// check if history.state is set and restore state from that if present. This
// may be set if the browser is restoring a tab with pushState. Otherwise, we
// need to replace the current state with the initial state so that we get an
// appropriate state pop event when returning to the starting state with the
// back button.
//
// popHandler - PopHandler implementation that will receive the initial
//              history.state or be used to get the initial state.
//
// Returns nothing.
PushState.prototype.pushStateInit = function(popHandler) {
  // Remember the handler if we haven't seen it before.
  this._rememberPopHandler(popHandler);

  if (this.pushStateIsSupported()) {
    if (this.window.history.state) {
      // Simulate a pop state for the stored state.
      this._stateDidPop({ state: this.window.history.state });
    } else {
      // Initialize current state and replace initial non-state with current.
      this._setCurrentStateFromUrl(popHandler);
      var url = popHandler.stateToUrl(this.currentState);
      this.window.history.replaceState(this.currentState, '', url);
    }
  }
};

// Set the current state by pushing it onto the stack. If the current
// browser doesn't support pushState, then the state is immediately
// propagated to window.location by using the handler to constuct a URL
// using the given state.
//
// popHandler - PopHandler implementation that will receive the corresponding
//              pop of this state.
// state      - An Object describing the state.
//
// Returns Boolean true if the state was pushed.
PushState.prototype.pushState = function(popHandler, state) {
  // Remember the handler if we haven't seen it before.
  this._rememberPopHandler(popHandler);

  // Tie the handler to the state.
  state['_popHandler'] = popHandler.name;

  // Ensure that we have a current state to start with
  if (!this.currentState) this._setCurrentStateFromUrl(popHandler);

  // If the state has changed, push it to the browser.
  if (!_.isEqual(state, this.currentState)) {
    if (this.pushStateIsSupported()) {
      // Update the current state and push the state to the browser.
      this.currentState = state;
      var url = popHandler.stateToUrl(state);
      this.window.history.pushState(state, '', url);
      if (this.window._gaq) this.window._gaq.push(['_trackPageview', url]);
      return true;
    } else {
      // Set the window location and refresh the page.
      this.window.location = popHandler.stateToUrl(state);
      return true;
    }
  }
  return false;
};

PushState.prototype._rememberPopHandler = function(popHandler) {
  if (!this.handlers[popHandler.name])
    this.handlers[popHandler.name] = popHandler;
};

PushState.prototype._setCurrentStateFromUrl = function(popHandler) {
  this.currentState = popHandler.urlToState(this.window.location);
  this.currentState['_popHandler'] = popHandler.name;
};

PushState.prototype._stateDidPop = function(event) {
  if (event.state) {
    var state = event.state;
    if (!_.isEqual(state, this.currentState)) {
      this.currentState = state;
      var popHandler = this.handlers[state['_popHandler']];
      // TODO: handle transition from one handler to another.
      popHandler.restoreState(state);
    }
  }
};

// PushState singleton created on demand.
var ps;
function getPushState() {
  if (!ps) ps = new PushState(window);
  return ps;
}

// Public: Initialize application state.
//
// popHandler - PopHandler implementation that will receive the initial
//              history.state or be used to get the initial state.
//
// Returns nothing.
function pushStateInit(popHandler) {
  getPushState().pushStateInit(popHandler);
}

// Public: Set application state.
//
// popHandler - PopHandler that will handle restoration
//              of this state.
// state      - Object describing state.
//
// Returns Boolean true if the state was pushed.
function pushState(popHandler, state) {
  return getPushState().pushState(popHandler, state);
}

// Public: Determine the browser's push state support.
//
// Returns Boolean true if the browser supports push state.
function pushStateIsSupported() {
  return getPushState().pushStateIsSupported();
}

module.exports = {
  // Export the constructor for testing purposes.
  PushState: PushState,

  pushState: pushState,
  pushStateInit: pushStateInit,
  pushStateIsSupported: pushStateIsSupported
};
